import { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { Text } from '../SubComponents/Text';
import { ThemeName } from '../Style/types';

const Container = styled.div<{ active: boolean }>`
  display: flex;
  align-items: center;
  margin: 0 10px 0 30px;
  padding: 0;
  max-width: 600px;
  background-color: ${(props) => props.theme.colors.uspBanner.backgroundColor};

  ${(props) => props.theme.name === ThemeName.Starboard && 'border-radius: 360px;'}
  grid-column: 2;
  justify-content: ${(props) =>
    props.theme.name === ThemeName.Starboard ? 'center' : 'flex-start'};

  transition: opacity 0.3s;
  opacity: ${(props) => (props.active ? '1' : '0')};

  @media screen and (max-width: 767px) {
    ${(props) => props.theme.name === ThemeName.Starboard && 'grid-row: 2;'}
    grid-column: 1/3;
    overflow: hidden;
    margin: 0;
    padding: 3px 6px;
    justify-content: center;
    min-height: 25px;
  }
`;

const AnimatedText = styled(Text)`
  transition: opacity 0.3s;
  font-size: 16px;
  color: ${(props) => props.theme.colors.uspBanner.textColor};
  text-align: ${(props) =>
    props.theme.name === ThemeName.Starboard ? 'center' : 'left'};

  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
`;

const INTERVAL = 3500;

interface UspBannerProps {
  uspBannerEntries: { text: string }[] | undefined;
}

const UspBanner = (props: UspBannerProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [opacity, setOpacity] = useState<0 | 1>(1);
  const usp = props.uspBannerEntries?.[currentIndex]?.text || '';

  useEffect(() => {
    const length = props.uspBannerEntries?.length || 0;
    const indexTimeout = setTimeout(() => {
      const newIndex = currentIndex + 1 >= length ? 0 : currentIndex + 1;
      setCurrentIndex(newIndex);
    }, INTERVAL);

    const fadeInTimeout = setTimeout(() => {
      setOpacity(1);
    }, 10);

    const fadeOutTimeout = setTimeout(() => {
      if (length > 1) {
        setOpacity(0);
      }
    }, INTERVAL - 300);

    return () => {
      clearTimeout(indexTimeout);
      clearTimeout(fadeInTimeout);
      clearTimeout(fadeOutTimeout);
    };
  }, [currentIndex, props.uspBannerEntries]);

  return (
    <Container active={Boolean(usp)}>
      <AnimatedText opacity={opacity}>{usp}</AnimatedText>
    </Container>
  );
};

export default UspBanner;
